import { Link } from "react-router-dom";
import { LangLink } from "@/components/LangLink";
import { Seo } from "@/components/Seo";
import { Button } from "@/components/ui/button";

export default function NotFound() {
  return (
    <>
      <Seo title="Page not found" path="/404" />
      <div className="container-site flex flex-col items-center justify-center py-28 text-center">
        <p className="font-mono text-sm text-boomerang">404</p>
        <h1 className="mt-3 font-display text-4xl">Page not found</h1>
        <p className="mt-2 max-w-md text-sm text-muted-foreground">The page you're looking for doesn't exist or has moved.</p>
        <Button asChild className="mt-6"><LangLink to="/">Back to home</LangLink></Button>
      </div>
    </>
  );
}
